<div class="action-buttons">
  <button mat-flat-button class="form-button save" (click)="onSave()" [disabled]="loading">
    <mat-icon class="form-button-icon">save</mat-icon>
    <span class="form-button-text">SAVE</span>
  </button>
  <button mat-stroked-button class="form-button cancel" (click)="onCancel()" [disabled]="loading">CANCEL</button>
</div>